import "./BathroomRenovation.module.css";
import Header from "@/reusable_sections/Header";
import CompleteRefurbishments from "./sections/CompleteRefurbishments";
import OurStepByStepProcess from "./sections/OurStepByStepProcess";
import RenovationFaq from "./sections/RenovationFaq";
import Footer from "@/reusable_sections/Footer";
export default function BathroomRenovationPage() {
  return <div>
      <Header />
      <CompleteRefurbishments />
      <OurStepByStepProcess />
      <RenovationFaq />
      <Footer />
    </div>;
}